import Vue from 'vue'

Vue.filter('leftPad',  function (value) {
    return ('00' + value).slice(-2);
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
